import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JobDictionary } from 'src/app/models/jobDictionary.model';
import { JobDictionaryService } from 'src/app/services/job-dictionary.service';
import { FormComponent, IFormDialogData } from 'src/app/shared/form/form.component';

@Component({
  standalone: false,
  selector: 'app-job-dictionary-dialog',
  templateUrl: './job-dictionary-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./job-dictionary-dialog.component.scss']
})
export class JobDictionaryDialogComponent extends FormComponent<JobDictionary> implements OnInit {

  duplicateCodeError = false;

  constructor(
    dialogRef: MatDialogRef<JobDictionaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
    jobDictionaryService: JobDictionaryService,
    protected injector: Injector
  ) {
    super(dialogRef, jobDictionaryService, data, 'Job Grouping', injector);
  }

  ngOnInit(): void {
    this.isFormLoading = true;
    this.getEntity().subscribe({
      next: (entity) => {
        this.entity = entity;
        this.isFormLoading = false;
      },
      error: (error) => {
        this.toastService.showError(error);
        this.isFormLoading = false;
      }
    });
  }

  getNewObject(): JobDictionary {
    const entity = new JobDictionary();
    entity.isActive = true;
    return entity;
  }

  validate(): boolean {
    return !!this.entity?.code?.trim() && !!this.entity?.name?.trim();
  }

  clearCodeError(): void {
    this.duplicateCodeError = false;
  }

  override handleError = (error: unknown): void => {
    this.isLoading = false;
    const message = (error as { error?: { message?: string } })?.error?.message ?? '';
    if (message.toLowerCase().includes('code already exists')) {
      this.duplicateCodeError = true;
      return;
    }
    this.toastService.showError(error);
  };
}
